import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  createAuthLink,
  createGraphQLErrorNotificationLink,
  FRONT_GRAPHQL_OPTIONS,
  FrontGraphQLModule,
  FrontGraphQLOptions,
} from '@onep/front-common-lib/graphql';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ApolloModule } from 'apollo-angular';

export function createFrontGraphQLOptions(
  oidcSecurityService: OidcSecurityService
): FrontGraphQLOptions {
  return {
    uri: environment.gqlUrl,
    monitoring: {
      name: 'shared-info',
    },
    extraLinks: [
      createAuthLink({
        tokenProvider: () => {
          if (oidcSecurityService.getToken()) {
            return Promise.resolve(oidcSecurityService.getToken());
          } else {
            return Promise.resolve(null);
          }
        },
      }),
    ],
  };
}

@NgModule({
  imports: [FrontGraphQLModule, ApolloModule],
  exports: [FrontGraphQLModule],
  providers: [
    {
      provide: FRONT_GRAPHQL_OPTIONS,
      useFactory: createFrontGraphQLOptions,
      deps: [OidcSecurityService],
    },
  ],
})
export class GraphQLModule {}
